import { DEEP_LINK_FEATURES } from 'const/deepLink'

interface DeepLinkAnalyticsParams {
  client: string
  clientId: string
  feature: string
}

// Keys are read by the UTAG/Adobe tag layer when the syfPageView event fires
const STORAGE_KEYS = {
  client: 'deepLinkAnalyticsClient',
  clientId: 'deepLinkAnalyticsClientId',
  feature: 'deepLinkAnalyticsFeature',
  status: 'deepLinkAnalyticsStatus'
} as const

export const setDeepLinkAnalyticsSession = ({
  client,
  clientId,
  feature
}: DeepLinkAnalyticsParams): void => {
  sessionStorage.setItem(STORAGE_KEYS.client, client)
  sessionStorage.setItem(STORAGE_KEYS.clientId, clientId)
  sessionStorage.setItem(STORAGE_KEYS.feature, feature)
}

export const isDeepLinkSession = (): boolean =>
  !!sessionStorage.getItem(STORAGE_KEYS.feature)

export const isRewardsDeepLink = (): boolean =>
  sessionStorage.getItem(STORAGE_KEYS.feature) === DEEP_LINK_FEATURES.rewards

export const setDeepLinkStatus = (status: 'success' | 'failure'): void => {
  if (typeof window === 'undefined') return
  if (!isDeepLinkSession()) return
  const currentStatus = sessionStorage.getItem(STORAGE_KEYS.status)
  if (currentStatus) return
  sessionStorage.setItem(STORAGE_KEYS.status, status)
}
